import { ExternalLinks } from '_constants/externalLinks/type'

const faqDomainUrl = 'https://www.blank.app/it/domande-frequenti'

export const BLANK_EXTERNAL_LINKS_IT: ExternalLinks = {
  cguLink: 'https://www.blank.app/it/termini-e-condizioni/cgu-piattaforma',
  bankingOrganizationPrivacyPolicyLink:
    'https://www.blank.app/it/protezione-dei-dati/informativa-privacy',
  brandPrivacyPolicyLink: '',
  appStoreLink:
    'https://apps.apple.com/it/app/blank-conto-business/id1522046776',
  googlePlayLink:
    'https://play.google.com/store/apps/details?id=app.blank.mobile&hl=it',
  faq: faqDomainUrl,
  mandateSepa: faqDomainUrl,
  invoicingFaq: faqDomainUrl,
  requestHelp: faqDomainUrl,
  contactAdvisorPage: 'https://www.blank.app/it/contatti',
  rcProInfo: '',
  decadeGuaranteeInfo: '',
  multiriskInfo: '',
  legalPlaceCompany: '',
  helpNonDiffusible: faqDomainUrl,
  helpNonEligible: faqDomainUrl,
  helpBeneficialOwners: faqDomainUrl,
  helpNonAllowed: faqDomainUrl,
  urssaf: {
    portal: '',
    microEntrepreneurs: '',
    socialContributions: '',
    sepaMandate: '',
    faq: '',
    tdaeStatusHelp: '',
    tdaePaymentAuthorization: '',
    tou: '',
  },
  faqWhoIsBlankFor: faqDomainUrl,
  fatcaCGU: '',
  psdFAQ: faqDomainUrl,
  legalLink: 'https://it.blank.app/documenti-legali',
  supportEmail: 'servizio.clienti@blank.app',
  securityEmail: 'servizio.clienti@blank.app',
  leadEmail: 'servizio.clienti@blank.app',
  sepaTransfer: faqDomainUrl,
  compareOffers: 'https://it.blank.app/tariffe',
  touBankAccount:
    'https://www.blank.app/it/termini-e-condizioni/termini-e-condizioni-conto-di-pagamento',
  transparencyPolicy:
    'https://www.blank.app/it/termini-e-condizioni/foglio-informativo',
  kycHelp: faqDomainUrl,
  legalStatus: '',
  capitalDeposit: '',
  discoverManagementToolsOffer: '',
  sponsorshipFAQ: '',
  priceBrochure:
    'https://www.blank.app/it/termini-e-condizioni/foglio-informativo',
  changeNonDiffusibleCompany: '',
  sponsorshipInvitationLink: '',
  requestDeviceResetFAQ: `${faqDomainUrl}/che-cose-il-dispositivo-di-sicurezza`,
  accountClosingFaq: `${faqDomainUrl}/come-posso-chiudere-il-mio-conto-blank`,
  bankScamPreventionLink: '',
  transferFAQ: `${faqDomainUrl}/come-posso-fare-un-bonifico`,
  atecoCodeFAQ: `${faqDomainUrl}/come-posso-recuperare-il-mio-codice-ateco-perche-e-richiesto`,
  partitaIVACertificateFAQ: `${faqDomainUrl}/come-posso-recuperare-il-certificato-di-attribuzione-della-partita-iva-perche-e-richiesto`,
}
